import { Dispatch } from "react";

export const updatePromoCode =
  (payload: Partial<PromoCodeAction>) =>
  async (dispatch: Dispatch<Partial<PromoCodeAction>>) => {
    console.log("ACTION PROMO CODE:", payload);
    dispatch({
      type: "UPDATE_PROMO_CODE",
      ...payload,
    });
  };
